import { useState } from "react";
import { faqList } from "@/mocks/erogeData";

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-8 bg-background-100/50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 text-accent-500 text-sm mb-2">
            <i className="ri-question-answer-line" />
            FAQ
          </span>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 tracking-wide">
            新手常见问题
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto leading-7">
            关于工口游戏的入门疑问，这里都有答案。如果还有别的困惑，欢迎随时留言。
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqList.map((item, idx) => {
            const isOpen = open === idx;
            return (
              <div
                key={item.q}
                className={`rounded-xl border transition-colors overflow-hidden ${
                  isOpen ? "border-primary-500/40 bg-background-100" : "border-background-200/60 bg-background-200/30"
                }`}
              >
                <button
                  onClick={() => setOpen(isOpen ? null : idx)}
                  className="w-full flex items-center justify-between gap-3 px-4 md:px-5 py-4 text-left cursor-pointer"
                  aria-expanded={isOpen}
                >
                  <span className="font-heading text-sm md:text-base text-foreground-950">{item.q}</span>
                  <span
                    className={`w-8 h-8 rounded-full flex items-center justify-center shrink-0 transition-all duration-300 ${
                      isOpen ? "bg-primary-500 text-foreground-950 rotate-180" : "bg-background-200/70 text-foreground-500"
                    }`}
                  >
                    <i className="ri-arrow-down-s-line text-lg" />
                  </span>
                </button>
                <div
                  className={`grid transition-all duration-300 ${isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}
                >
                  <div className="overflow-hidden">
                    <p className="px-4 md:px-5 pb-5 text-sm text-foreground-600 leading-7">{item.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}